export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterView.vue?vue&type=template&id=1255fba1"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SinisterView.vue?vue&type=template&id=1255fba1
// module id = 2100
// module chunks = 31